import { CSSProperties } from 'react';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import 'styles/react-datepicker.css';
import { clsx } from 'modules/Utils';
import InputSymphony from './InputSymphony';

interface DatePickerSymphonyProps {
    className?: string;
    style?: CSSProperties;
    selected: Date | null;
    onChange: (date: Date | null) => void;
    minDate?: Date | null;
    maxDate?: Date | null;
    placeholderText?: string;
    dateFormat?: string;
    disabled?: boolean;
    filterDate?: (date: Date) => boolean;
    label?: string;
    maxWidth?: number;
}

const DatePickerSymphony = ({
    className,
    style,
    selected,
    onChange,
    minDate = new Date(),
    maxDate,
    placeholderText = 'Select new date',
    dateFormat = 'MM/dd/yyyy',
    disabled = false,
    filterDate,
    label,
    maxWidth = 150,
}: DatePickerSymphonyProps) => {
    return (
        <>
            <style>
                {/* {`
                .react-datepicker__triangle {
                    left: -200px !important;
                }
                `} */}
            </style>
            <DatePicker
                className={clsx("datePickerElement", className)}
                selected={selected}
                onChange={(date: Date | null) => onChange(date)}
                minDate={minDate}
                maxDate={maxDate}
                dateFormat={dateFormat}
                placeholderText={placeholderText}
                autoComplete="off"
                wrapperClassName="datePickerElement"
                disabled={disabled}
                popperPlacement="bottom-start"
                // popperContainer={(props) => {
                //     return (
                //         <div className="datePickerPopperContainer" style={{ position: 'absolute', top: 0, left: 0, zIndex: 2000 }}>
                //             {props.children}
                //         </div>
                //     )
                // }}
                filterDate={filterDate}
                customInput={
                    <InputSymphony
                        className="editDatePickerInput"
                        value={selected ? dayjs(selected).format(dateFormat) : ''}
                        label={label}
                        maxWidth={maxWidth}
                    />
                }
            />
        </>
    )
}

export default DatePickerSymphony;